import './EncounterAdd.scss';

import {
  App,
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Spin,
} from 'antd';
import Heading from '../../common/Heading/Heading';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  updateEncounter,
  addEncounter,
  getEncountersDetails,
  submitEncounter,
} from '../../../network/encounters';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import EncounterInformation from './EncounterInformation';
import EncounterImpression from './EncounterImpression';
import EncounterItems from './EncounterItems';
import TeethSelection from './TeethSelection';
import { getAppointmentsDetails } from '../../../network/AppointmentDuration';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { ModalLastEncounter, ModalLastInvoices } from '../ModalApp/ModalApp';
import { IoBody } from 'react-icons/io5';
import ImageMapBody from '../../common/ImageMapBody/ImageMapBody';
const EncounterAdd = ({ t, edit, appointment }) => {
  const { id,idAppointment } = useParams();
  const [showTeeth, setShowTeeth] = useState();
  const [showBody, setShowBody] = useState();
  const [selectedParts, setSelectedParts] = useState([]);
    const [dataSource, setDataSource] = useState([{}]);
    // console.log(dataSource, 'dataSourceqwjdoqwjpfojqwpjfpqwjkpfo;');
    
  const [openModalLastEncounter, setOpenModalLastEncounter] = useState(false);
  const [openModalLastInvoice, setOpenModalLastInvoice] = useState(false);
  const [form] = Form.useForm();
  const [dental, setDental] = useState([]);
  // const [submitEncounte, setSubmitEncounte] = useState(false);
  const navigate = useNavigate();
  const [loadingAddSave, setLoadingAddSave] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [dataStatus, setDataStatus] = useState(null);
  const [selectName, setSelectName] = useState('');
  const client = useQueryClient();
  const { message } = App.useApp();
  const { mutate: onAddEncounter } = useMutation({
    mutationKey: ['addEncounter'],
    mutationFn: (body) => (edit ? updateEncounter(id,body) : addEncounter(body)),
    onSuccess: (data) => {
      console.log(data, 'data');
      setLoadingAddSave(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(edit ? "Updated successfully" : "Added successfully");
      client.invalidateQueries({ queryKey: [queryKeys.getEncountersList] });
      form.resetFields();
      // edit && navigate('/encounters');
      edit && dataStatus !== 0 && navigate('/encounters');
    },
    onError: (error) => {
      setLoadingAddSave(false);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      // message.error(error);
    },
  });
  const { mutate: onSubmitEncounter } = useMutation({
    mutationKey: ['submitEncounter'],
    mutationFn: (name) => submitEncounter(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      console.log(data?.message, 'data');
      setLoadingAddSave(false);
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500 || data?.message?.status === 417) {
        // console.log(data?.message?.status, 'data');
        message.error(data?.message?.message);
        return false;
      }
      submitButton && navigate('/encounters');
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getEncountersList],
      });
    },
    onError: (error) => {
      setLoadingAddSave(false);
      // message.error(error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const { data: getAppointmentsInfo, isLoading: isLoadingAppointments } =
    useQuery({
      queryKey: [queryKeys.getAppointmentsDetails, idAppointment],
      queryFn: () => getAppointmentsDetails(idAppointment),
      keepPreviousData: true,
      enabled: !!appointment && !!idAppointment,
    });

  const onFinish = (values) => {
    // console.log('Finish:', values);
    setLoadingAddSave(true);
    onAddEncounter({
        ...values,
        // custom_item: values?.custom_item[0]?.item_code,
        // custom_item: values?.custom_item?.map((item) => item.item_code),
        // custom_item:dataSource?.map((item) => ({ ...item })),
        items:dataSource?.map((item) => ({ ...item })),
        // selected_teeth : ,
        symptoms:values?.symptoms?.map((item) => {return {complaint: item}}),
        diagnosis:values?.diagnosis?.map((item) => {return {diagnosis: item}}),
        encounter_comment: values?.encounter_comment,
        encounter_date: values?.encounter_date?.format('YYYY-MM-DD'),
        encounter_time: values?.encounter_time?.format('HH:mm:ss'),
        // custom_selected_teeth: dental?.join(''),

        custom_selected_teeth: dental?.length > 0 ? dental?.join(',') : selectedParts?.join(','),
        name: id,
        // name: edit ? id : getAppointmentsInfo?.message?.message?.name ? getAppointmentsInfo?.message?.message?.name : "",
        // name: id ? id : getAppointmentsInfo?.message?.message?.name ? getAppointmentsInfo?.message?.message?.name : "",
    })
  };
  const patient_Value = Form.useWatch('patient', form);
  const practitioner_Value = Form.useWatch('practitioner', form);

  const { data: encountersInfo, isLoading: encountersInfoLoading } = useQuery({
    queryKey: [queryKeys.getEncountersDetails, id],
    queryFn: () => getEncountersDetails(id),
    // keepPreviousData: true,
    enabled: !!edit,
  });
  useEffect(() => {
    if (edit && encountersInfo) {
      setDataSource(
        encountersInfo?.data?.items?.length > 0 ?
        encountersInfo?.data?.items?.map((item) => ({
          ...item
        })) : [{}]
      )
      const teeth_data =
        encountersInfo?.data?.custom_selected_teeth;
      setDental(teeth_data?.split(',') || []);
      setDataStatus(encountersInfo?.data?.docstatus);
      setSelectedParts(teeth_data?.split(',') || []);
      form.setFieldsValue({
        ...encountersInfo?.data,
        appointment: encountersInfo?.data?.appointment,
        custom_materials:
          encountersInfo?.data?.custom_materials?.map(
            (item) => item?.material
          ),
        patient:
          encountersInfo?.data?.patient,
        patient_sex: encountersInfo?.data?.patient_sex,
        // patient_age: `${Math.floor(years)} years ${months} months`,
        patient_age: encountersInfo?.data?.patient_age,
        practitioner:
          encountersInfo?.data?.practitioner,
        medical_department:
          encountersInfo?.data?.medical_department,
        encounter_date: dayjs(
          encountersInfo?.data?.encounter_date
        ),
        // encounter_time:encountersInfo?.data?.encounter_time,
        encounter_time: dayjs(
          encountersInfo?.data?.encounter_time,
          'HH:mm'
        ),
        symptoms: encountersInfo?.data?.symptoms?.map(
          (item) => item?.complaint
        ),
        diagnosis: encountersInfo?.data?.diagnosis?.map(
          (item) => item?.diagnosis
        ),
        custom_item: [
          ...encountersInfo?.data?.items,
        ],
      });
    }
    const showThee = edit
      ? encountersInfo?.data?.medical_department ===
          'Dental' ||
        getAppointmentsInfo?.message?.message?.department ===
          'Dental'
      : false;
    setShowTeeth(showThee);
    setShowBody(encountersInfo?.data?.medical_department === 'Dermatology')
  }, [edit, encountersInfo,id]);
  useEffect(() => {
    if(getAppointmentsInfo &&appointment && !edit){
      // const birthDate = dayjs(encountersInfo?.data?.patient_age);
      // const today = dayjs();
      // const years = today.diff(birthDate, 'year', true);
      // const months = today.diff(birthDate, 'month') % 12;
      form.setFieldsValue({
        ...getAppointmentsInfo?.message?.message,
                appointment: getAppointmentsInfo?.message?.message?.name,
                patient:
                  getAppointmentsInfo?.message?.message?.patient,
                patient_sex:
                  getAppointmentsInfo?.message?.message?.patient_sex,
                patient_age:
                  getAppointmentsInfo?.message?.message?.patient_age || 0,
                practitioner:
                  getAppointmentsInfo?.message?.message?.practitioner,
                medical_department:
                  getAppointmentsInfo?.message?.message?.department,
                encounter_date: dayjs(
                  getAppointmentsInfo?.message?.message?.appointment_date
                ),
                encounter_time: dayjs(
                  getAppointmentsInfo?.message?.message?.appointment_time,
                  'HH:mm'
                ),
                custom_item: [{}],
      })
      const showThee =
        getAppointmentsInfo?.message?.message?.department ===
        'Dental'
          ? true
          : false;
        setShowBody(getAppointmentsInfo?.message?.message?.department === 'Dermatology')
      setShowTeeth(showThee);
      setDataSource(
        getAppointmentsInfo?.message?.message?.custom_item?.lenght ?
        getAppointmentsInfo?.message?.message?.custom_item?.map((item) => ({
          ...item
        })) : [{}]
      )
    }  else{
      setShowTeeth(false);
      // setDataSource([{}])
    }
  }, [getAppointmentsInfo,appointment]);
  if (encountersInfoLoading || isLoadingAppointments) {
    return (
      <div
        className=""
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="encounter-add">
      <Heading
        title={t.Encounters}
        subTitle={ edit ? t.editEncounter : t.addEncounter}
        path="/encounters"
      />
      <Card>
        <Flex align="center" justify="space-between" gap={10}>
          <h4 className="title-card">{t.enterEncounterInformation}</h4>
          {patient_Value && (
            <Flex gap={10}>
              <Button
                type="primary"
                onClick={() => {
                  setOpenModalLastEncounter(true);
                }}
                icon={<FaCloudDownloadAlt />}
              >
                {t.GetLastEncounters}
              </Button>
              <Button
                type="primary"
                icon={<FaCloudDownloadAlt />}
                onClick={() => {
                  setOpenModalLastInvoice(true);
                }}
              >
                {t.GetLastInvoices}
              </Button>
            </Flex>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="encounter-add"
          onFinish={onFinish}
          form={form}
          initialValues={
               {
                  custom_item: [{}],
                }
          }
        >
          <Row gutter={[16, 0]}>
            <EncounterInformation
              t={t}
              form={form}
              edit={edit}
              id={id}
              setShowTeeth={setShowTeeth}
              setShowBody={setShowBody}
            />
            {!showTeeth && <EncounterImpression t={t} form={form} />}
            <EncounterItems t={t} form={form} setDataSource={setDataSource} dataSource={dataSource} />
            <Col span={24}>
            {showBody && (
              <>
              <Divider orientation="left">{t.bodyMap}</Divider>
              <ImageMapBody
                  t={t}
                  form={form}
                  setSelectedParts={setSelectedParts}
                  selectedParts={selectedParts}
              />
            </>
          )}
            </Col>
          </Row>
          {showTeeth && (
            <TeethSelection
              t={t}
              form={form}
              setDental={setDental}
              dental={dental}
            />
          )}
          <>
            <Divider orientation="left">{t.reviewDetails}</Divider>
            <Col span={24}>
              <Form.Item name="encounter_comment" label={t.reviewDetails}>
                <Input.TextArea
                  placeholder={t.reviewDetails}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
          </>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
            {t.Cancel}
            </Button>
            <Button
              type="primary"
              // ghost
              loading={loadingAddSave}
              onClick={() => {
                if(submitButton){
                  setLoadingAddSave(true)
                  onSubmitEncounter(selectName);
                } else{
                  form.submit();
                }
              }}
              // onClick={() => setSubmitEncounte(false)}
            >
              {submitButton ? t.submit : edit ? t.edit : t.Save}
            </Button>
            {/* <Button
                type="primary"
                htmlType="submit"
                loading={loadingAdd}
                onClick={() => setSubmitEncounte(true)}
              >
                {edit ? t.edit : t.SaveSubmit}
              </Button> */}
          </div>
        </Form>
      </Card>
      <ModalLastEncounter
        open={openModalLastEncounter}
        setOpen={setOpenModalLastEncounter}
        t={t}
        patientId={patient_Value}
      />
      <ModalLastInvoices
        open={openModalLastInvoice}
        setOpen={setOpenModalLastInvoice}
        t={t}
        patientId={patient_Value}
        practitionerId={practitioner_Value}
      />
    </div>
  );
};

export default EncounterAdd;
